import { Builder } from "@builder.io/react";

/*
  This file is used to register the editor settings for the Builder.io editor.
  It is used to define the design tokens that are available in the editor.
  It is also used to define the components that are available in the editor.
  It is also used to define the properties that are available in the editor.
  It is also used to define the events that are available in the editor.
  It is also used to define the actions that are available in the editor.
*/

Builder.register("editor.settings", {
  designTokens: {
    colors: [
      { name: "Neutral-100", value: "var(--color-neutral-100, #ffffff)" },
      { name: "Neutral-80", value: "var(--color-neutral-80, #ededed)" },
      { name: "Neutral-60", value: "var(--color-neutral-60, #e3e3e3)" },
      { name: "Neutral-40", value: "var(--color-neutral-40, #5c5b60)" },
      { name: "Neutral-20", value: "var(--color-neutral-20, #393839)" },
      { name: "Primary", value: "var(--color-primary, #cf4b08)" },
      { name: "Secondary", value: "var(--color-secondary, #eee478)" },
      { name: "Tertiary", value: "var(--color-tertiary, #d4ebf0)" },
      { name: "Quaternary", value: "var(--color-quaternary, #8f3536)" },
      { name: "Alert", value: "var(--color-alert, #da1a40)" },
    ],
    spacing: [
      { name: "xl", value: "var(--spacing-xl, 32px)" },
      { name: "lg", value: "var(--spacing-lg, 16px)" },
      { name: "md", value: "var(--spacing-md, 8px)" },
      { name: "sm", value: "var(--spacing-sm, 4px)" },
      { name: "sm", value: "var(--spacing-xs, 4px)" },
      { name: "none", value: "var(--spacing-none, 0px)" },
    ],
    fontFamily: [
      { name: "Primary", value: "var(--font-primary, 'Lufga', sans-serif)" },
      {
        name: "Secondary",
        value: "var(--font-secondary, 'Lufga', sans-serif)",
      },
    ],
    fontSize: [
      { name: "10", value: "var(--size-10, 12px)" },
      { name: "20", value: "var(--size-20, 14px)" },
      { name: "30", value: "var(--size-30, 16px)" },
      { name: "40", value: "var(--size-40, 18px)" },
      { name: "50", value: "var(--size-50, 20px)" },
      { name: "60", value: "var(--size-60, 24px)" },
      { name: "70", value: "var(--size-70, 36px)" },
      { name: "80", value: "var(--size-80, 48px)" },
    ],
    lineHeight: [
      { name: "10", value: "var(--height-10, 16px)" },
      { name: "20", value: "var(--height-20, 20px)" },
      { name: "30", value: "var(--height-30, 24px)" },
      { name: "40", value: "var(--height-40, 28px)" },
      { name: "50", value: "var(--height-50, 32px)" },
      { name: "60", value: "var(--height-60, 36px)" },
      { name: "70", value: "var(--height-70, 48px)" },
      { name: "80", value: "var(--height-80, 60px)" },
    ],
    // other design tokens
  },
});
